// extracted by mini-css-extract-plugin
export var darkmodeStyle = "DarkModeToggle-module--darkmodeStyle--20736";